"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var PlayerLevelEditor = /** @class */ (function (_super) {
    __extends(PlayerLevelEditor, _super);
    function PlayerLevelEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.EMAIL_TYPE_CODE_LEVEL = 6;
        _this.MESSAGE_TYPE_CODE_LEVEL = 4;
        return _this;
    }
    PlayerLevelEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_LB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({
                _brands: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    description: _item.description,
                    level_tag: _item.level_tag,
                    level_num: _item.level_num,
                    _brands: [],
                    tabKey: this.key_main
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование уровня"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                brand_id: 0,
                brand_title: "",
                description: "",
                level_tag: "",
                level_num: 0,
                _brands: [],
                tabKey: this.key_main
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание уровня"]);
            });
        }
        this.props.listBrands.LoadData();
        this.doReSetRules();
    };
    PlayerLevelEditor.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_LB);
    };
    PlayerLevelEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            brand_rules: { isError: false },
        });
    };
    PlayerLevelEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [имя] не заполнено!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" } });
            return false;
        }
        return true;
    };
    PlayerLevelEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                level_tag: this.state.level_tag,
                level_num: this.state.level_num,
                title: this.state.title,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Уровень пользователя изменен!");
            });
        }
    };
    PlayerLevelEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                level_tag: this.state.level_tag,
                level_num: this.state.level_num,
                brand_id: this.state.brand_id,
                title: this.state.title,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Уровень пользователя добавлен!");
            });
        }
    };
    PlayerLevelEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerLevelEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить уровень пользователя";
        }
        else {
            return "Изменить уровень пользователя";
        }
    };
    PlayerLevelEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    PlayerLevelEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.state._brands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Номер уровня:", placeholder: "Введите номер уровня" }, values: { max: 999, min: 0, value: this.state.level_num }, onValueChanged: function (newVal) { _this.setState({ level_num: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            this.getDownButtons()));
    };
    PlayerLevelEditor.prototype.getContent = function () {
        // if (this.state.tabKey === this.key_main) {
        return this.getMainContent();
        // }
        // if (this.state.tabKey === this.key_messages) {
        //     return this.getMessagesContent();
        // }
        // return null;
    };
    PlayerLevelEditor.prototype.render = function () {
        /*
            <TabEditorContainer
                onGoBackClick={this.OnGoBackClick.bind(this)}
                title={this.getFormTitle()}
                state={this.props.state}
                maxHeight={500}
                activeTabKey={this.state.tabKey}
                tabs={[
                    { key: this.key_main, tab: "Основные" },
                    { key: this.key_messages, tab: "Уведомления" }
                ]}
                onTabChange={(key) => { this.setState({ tabKey: key }) }}
            >
                {this.getContent()}

            </TabEditorContainer>
        
        */
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 450 }, this.getContent()));
    };
    return PlayerLevelEditor;
}(React.Component));
exports.default = PlayerLevelEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/PlayerLevelEditor.tsx
// module id = 1948
// module chunks = 0